import { render, staticRenderFns } from "./projectByAnnoucement.vue?vue&type=template&id=b912b844&"
import script from "./projectByAnnoucement.vue?vue&type=script&lang=ts&"
export * from "./projectByAnnoucement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports